// web_components/wcContent/wcContent_Renderer.ts

/**
 * Generates the HTML for the wc-content component.
 * Handles CSS, variables, etc.
 *
 * @param {object} dataAttributes - Data attributes for styling and contextual information.
 * @param {string} instanceId - A unique instance ID for generating unique element IDs.
 * @returns {string} - The HTML string for the content component.
 */
export function renderProductHTML(dataAttributes: any, instanceId: string): string {
	// Initialize styleTag to an empty string
	let styleTag = '';

	// Check if 'css' exists in dataAttributes and is an object
	if (dataAttributes.css && typeof dataAttributes.css === 'object') {
		styleTag = `<style>`;
		for (const [selector, styles] of Object.entries(dataAttributes.css)) {
			styleTag += `${selector} { ${styles} }`;
		}
		styleTag += `</style>`;
	}

	// Access variables and assign to 'variables', defaulting to an empty object if undefined
	const variables = dataAttributes.variables || {};

	return `
        ${styleTag}
        <section id="${instanceId}" class="wc-content">
        <div class="wc-content__media-wrapper">
        ${
			variables.hasPart?.embedUrl
				? `
			<iframe src="${variables.hasPart.embedUrl}" title="${variables.hasPart.videoTitle}" loading="lazy" allow="accelerometer; autoplay; clipboard-write; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>	
`
				: `
			<img 
			  class="wc-content__image" 
			  src="${variables.image.representations[0].url}" 
			  alt="${variables.image.alternateName}" 
			  loading="lazy">`
		}
		</div>
		  <div class="wc-content__copy-wrapper">
			<h2 class="wc-content__heading">${variables.name}</h2>
			<h3 class="wc-content__subheading">${variables.additionalProperty.find((prop: { name: string }) => prop.name === 'Subheading').value}</h3>
			<p class="wc-content__paragraph-1">${variables.text[0]}</p>
			<p class="wc-content__paragraph-2">${variables.text[1]}</p>
			<p class="wc-content__paragraph-3">${variables.text[2]}</p>
			${
				variables.potentialAction.object?.identifier
					? `
				<form class="wc-content__atb-form">
					<input name="productId" class="wc-content__product-id" value="${variables.potentialAction.object?.identifier}" type="hidden" />
					<input name="productType" class="wc-content__product-type" value="${variables.potentialAction.object?.category}" type="hidden" />
					<button type="submit" class="wc-content__cta">Add to basket</button>
				</form>
				`
					: `
				<a href="${variables.potentialAction.target}" class="wc-content__cta">${variables.potentialAction.name}</a>`
			}
		  </div>
		</section>
    `;
}
